export const defaultBorderRadius = "5px";
export const defaultFontSize = '1rem';
